export default "__VITE_ASSET__0e296e35__"